import Amplify from "aws-amplify";
import request from "superagent";
import APP_ENV from "../Environment";

Amplify.configure({
    Auth: {
        region: 'ap-northeast-1', // REQUIRED - Amazon Cognito Region
        userPoolId: APP_ENV.USERPOOLID, //OPTIONAL - Amazon Cognito User Pool ID
        userPoolWebClientId: APP_ENV.USERPOOLWEBCLIENTID, //OPTIONAL - Amazon Cognito Web Client ID
        authenticationFlowType: 'USER_PASSWORD_AUTH',
    }
});

export const postLogin = (idToken, access_url) => {
    return new Promise((resolve, reject) => {
        request
            .post(APP_ENV.BFF + access_url)
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${idToken}`)
            .end((err, res) => {
                if (err) {
                    reject(err);
                    return;
                }
                let gene = res.body.cookies.gene
                resolve({ gene })
            });
    });

};

const postToken = (code) => {
    return new Promise(((resolve, reject) => {
        request
            .post(`${APP_ENV.USERPOOLDOMEIN}/oauth2/token`)
            .type('form')
            .send({
                grant_type: 'authorization_code',
                client_id: APP_ENV.USERPOOLWEBCLIENTID,
                redirect_uri: `${APP_ENV.FRONT_URL}/oauth`,
                code
            })
            .end((err, res) => {
                if (err) {
                    window.history.replaceState('','','/');
                    reject(err);
                }
                // ユーザ情報変更画面に遷移した際に、BFFとのやりとりが出来るようにid_tokenの中身をlocalStorageに格納
                localStorage.setItem("token_res",res.body.id_token)
                resolve(res.body.id_token);
            });

    }))
};

const checkCodeFormat = (query_code) => {
    return new Promise((resolve, reject) => {
        query_code ? resolve(query_code) : reject("oauth認証エラー")
    })
};

export const fetchSessionByOauth = async (query_code) => {
    try {
        const code = await checkCodeFormat(query_code);
        const idToken = await postToken(code);
        const session_res = await postLogin(idToken, '/user/sessions');
        return session_res;

    } catch (e) {
        throw e;
    }

};

export const fetchSession = async () => {
    try {
        const data = await Amplify.Auth.currentSession();
        const idToken = data.idToken.jwtToken;
        const session_res =  await postLogin(idToken, '/user/sessions');
        return session_res;

    } catch (e) {
        // oidcログインしている場合の再ログイン処理
        try {
            const session_res =  await postLogin(localStorage.getItem("token_res"), '/user/sessions');
            return session_res;

        } catch (err) {
            throw err;
        }
    }

};

export const moveToECCWithCookie = (gene) => {
    if (APP_ENV.GENE_COOKIE === 'gene') {
        document.cookie = `gene=${gene}; domain=.genelife.jp`;
    }
    window.location.href = APP_ENV.ECCMYPAGE;
};

export default fetchSession;